module.exports = __webpack_public_path__ + "static/media/Dacia-Duster.98b74302.jpg";